function initializeBreadcrumbs() {
  const toggleBtn = document.querySelector(
    '.breadcrumbs-from-template .breadcrumbs-toggle span'
  );
  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      document
        .querySelectorAll('.breadcrumbs-from-template li')
        .forEach((e) => {
          e.classList.remove('d-none');
        });
      document
        .querySelector('.breadcrumbs-from-template .breadcrumbs-toggle')
        .classList.add('d-none');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initializeBreadcrumbs();
});
